export enum FeedbackType {
	PLATFORM_QUERY = 'PLATFORM_QUERY',
	INSUFFICIENT_CREDITS = 'INSUFFICIENT_CREDITS'
}

export enum FeedbackActionTypes {
	// Create Feedback
	CREATE_FEEDBACK_REQUEST = 'feedback/CREATE_FEEDBACK_REQUEST',
	CREATE_FEEDBACK_SUCCESS = 'feedback/CREATE_FEEDBACK_SUCCESS',
	CREATE_FEEDBACK_FAILURE = 'feedback/CREATE_FEEDBACK_FAILURE',

	// Fetch All Feedback
	FETCH_ALL_FEEDBACK_REQUEST = 'feedback/FETCH_ALL_FEEDBACK_REQUEST',
	FETCH_ALL_FEEDBACK_SUCCESS = 'feedback/FETCH_ALL_FEEDBACK_SUCCESS',
	FETCH_ALL_FEEDBACK_FAILURE = 'feedback/FETCH_ALL_FEEDBACK_FAILURE',

	// Get Feedback By ID
	GET_FEEDBACK_BY_ID_REQUEST = 'feedback/GET_FEEDBACK_BY_ID_REQUEST',
	GET_FEEDBACK_BY_ID_SUCCESS = 'feedback/GET_FEEDBACK_BY_ID_SUCCESS',
	GET_FEEDBACK_BY_ID_FAILURE = 'feedback/GET_FEEDBACK_BY_ID_FAILURE',

	// Resolve Feedback
	RESOLVE_FEEDBACK_REQUEST = 'feedback/RESOLVE_FEEDBACK_REQUEST',
	RESOLVE_FEEDBACK_SUCCESS = 'feedback/RESOLVE_FEEDBACK_SUCCESS',
	RESOLVE_FEEDBACK_FAILURE = 'feedback/RESOLVE_FEEDBACK_FAILURE',

	// Reset
	RESET_FEEDBACK_STATE = 'feedback/RESET_FEEDBACK_STATE'
}
